define('views/pages/account/AccountFavoritesView',['underscore', 'jquery', 'views/pages/account/AccountView', 'app', 'router', 'models/CartProductCollection', 'InternalLinkView', 'template!blocks/account/favorites', 'template!blocks/account/address-line',
        'views/blocks/AccountOrderView'
    ],
    function (_, $, AccountView, app, router, CartProductCollection, InternalLinkView, favoritesTemplate, addressLineTemplate, AccountOrderView) {

        //
        // Account Favorites View
        // représente la favorites de la page mon compte
        //

        var view;

        return AccountView.extend({


            events: {
                'click .btn-order': 'addProduct',
                'click .product-line .btn-icon': 'removeProductLike',
                'click [name=selectAllLikeProduct]': 'selectAllLikeProduct',

            },

            initialize: function () {
                view = this;
                AccountView.prototype.initialize.apply(view,arguments);

                view.listenTo(app.getCustomer(), 'change:likes', view.render);
                view.render();

            },
            removeProductLike: function (e) {
                
                var li = $(e.currentTarget).closest('li'), 
                    id_product = li.data('id_cart_product').toString();
                app.getCustomer().likeProduct(id_product);
                
                app.bottomNotice(t('Produit retiré des favoris !', 'Product'));
                
                li.slideUp(function () {
                    li.remove();
                });
            },
            selectAllLikeProduct: function (e) {
                view.$("[name='productFavorite[]']").prop('checked',$(e.currentTarget).is(':checked'));
            },
            addProduct: function () {

                var multipleProduct = [];
                view.$("[name='productFavorite[]']:checked").each(function () {
                    multipleProduct.push(
                        {
                            id_cart_product: $(this).attr('id'),
                            qty: 1
                        }
                    );
                });
                // si aucun produit n'est selectionné
                if(multipleProduct.length==0) return app.alert(t('Veuillez sélectionner un produit','Product'));

                var cart = app.getCart();
                cart.addMultipleProduct(multipleProduct)
                    .done(function(){
                        cart.goToCheckout();
                    });
            },
            render: function () {

                try {
                    var productFavoriteCollection = new CartProductCollection(),
                        cart = app.getCart(),
                        likes = app.getCustomer().get('likes');
                    _(likes).each(function (likeId) {
                        try {
                            var product = app.getProduct(likeId);
                            productFavoriteCollection.add({
                                id_product: product.id,
                                quantity: 1,
                                type: 'favorite',
                                cart: cart
                            });
                        }catch(err){
                            // le produit n'est pas disponible
                        }
                    }, view);

                    view.$el.html(favoritesTemplate({
                        productFavoriteCollection: productFavoriteCollection
                    }));
                }catch(err){

                }

                InternalLinkView.initializeLinksOfView(view);
            }
        });
    });
